import { PurchaserStatusTones } from '../utils/purchaser'
import { Badge } from './Badge'

export function StatusBadge({ status }: { status: string }) {
    const tone = PurchaserStatusTones[status as keyof typeof PurchaserStatusTones] ?? 'neutral'

    return (
        <Badge
            tone={tone}
            dot
            textTransform="capitalize"
        >
            {status}
        </Badge>
    )
}
